import { render, staticRenderFns } from "./system-logs.vue?vue&type=template&id=885d5ba4"
import script from "./system-logs.vue?vue&type=script&lang=js"
export * from "./system-logs.vue?vue&type=script&lang=js"
import style0 from "./system-logs.vue?vue&type=style&index=0&id=885d5ba4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports